import type { PostHogConfig } from 'posthog-js';

export function isPostHogConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY &&
      import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  );
}

export function getPostHogProviderOptions(): Partial<PostHogConfig> {
  const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string;
  const uiHost = import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST || null;

  return {
    api_host: apiHost,
    ui_host: uiHost,
    feature_flag_request_timeout_ms: 3000,
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      recordCrossOriginIframes: false,
    },
    enable_recording_console_log: true,
    logs: {
      captureConsoleLogs: true,
    },
  };
}
